<!-- 运维视图: 通知 -->
<template>
    <el-row>
        <el-col :span="24" style="background-color:#FBF8EE;padding:10px;">
            <el-row>
                <el-col :span="1">
                    <div class="notice-icon">
                        <img style="width: 100%" src="img/board/notice.svg" />
                    </div>
                </el-col>
                <el-col :span="12">
                    <operation-board-register :department-id="departmentId" :start-date-time="startDateTime" :end-date-time="endDateTime">
                    </operation-board-register>
                </el-col>
                <el-col :span="11">
                    <el-row type="flex" justify="end" style="margin-top: -5px;">
                        <operation-board-department-select ref="departmentSelect" v-model="departmentId" size="small">
                        </operation-board-department-select>
                    </el-row>
                </el-col>
            </el-row>
        </el-col>
    </el-row>
</template>

<script>
    import OperationBoardRegister from './operation-board-register';
    import OperationBoardDepartmentSelect from './operation-board-department-select';

    export default {
        name: "operation-board-notice",
        components: {
            OperationBoardRegister,
            OperationBoardDepartmentSelect,
        },
        props: {
            startDateTime: {},
            endDateTime: {},
        },
        data() {
            return {
                departmentId: null,
            };
        },
        watch: {
            departmentId: {
                handler() {
                    this.$emit('department-id-change', this.departmentId);
                },
            },
        },
        methods: {
            load() {
                this.loadDepartmentSelect();
            },
            loadDepartmentSelect() {
                if (this.$refs.departmentSelect == null) {
                    setTimeout(() => {
                        this.loadDepartmentSelect();
                    }, 100);
                } else {
                    this.$refs.departmentSelect.load();
                }
            },
        },
    }
</script>

<style scoped>
    * {
        line-height: 14px;
    }
    a.el-link.is-underline {
        text-decoration: none;
    }
</style>
